<template>
  <div class="excel-import">
    <div class="component m-auto" style="width:70%">
        <div class="component title-import">
          <span>{{ $t('exportFile.uploadListSources') }}</span>
        </div>
        <div class="component title-text-file">
          <span>{{ $t('exportFile.requiredFile') }} .csv</span>
        </div>
    </div>
    <input type="file" ref="fileInput" class="hidden" accept=".xlsx, .xls, .csv" @change="handleClick">
    <div
      @click="$refs.fileInput.click()"
      @drop="handleDrop"
      @dragover="handleDragover"
      @dragenter="handleDragover"
      class="mt-4 px-8 py-16 cursor-pointer text-center border-2 border-dashed d-theme-border-grey-light d-theme-dark-bg text-xl background-import p-6">
      <feather-icon icon="UploadIcon" svgClasses="h-16 w-16 stroke-current text-grey" class="block color-icon" />
      <div class="component m-auto" style="width:70%">
        <span class="text-import">{{ $t('exportFile.dragAndDropFileOrChoseFile') }}</span>
      </div>
      <span class="font-medium text-primary" @click.stop="$refs.fileInput.click()"></span>
      <!-- <vs-button type="border" @click.stop="$refs.fileInput.click()">Browse</vs-button> -->
    </div>
    <div class="vx-row p-6" v-if="checkFileImport">
      <div class="vx-col w-full md:w-2/12">
        <img src="@/assets/images/pages/csv.png" alt="" width="33" height="36">
      </div>
      <div class="vx-col w-full md:w-8/12">
        <div class="vx-row">
          <div class="vx-col md:w-10/12 w-full">
            <span class="file-name">{{fileName}}</span>
          </div>
          <div class="vx-col md:w-2/12 w-full percent-upload">
            <span>{{percentImport}}%</span>
          </div>
        </div>
        <vs-progress :percent="percentImport"></vs-progress>
      </div>
      <div class="vx-col md:w-2/12 w-full" v-if="checkImport">
        <img class="mt-2" src="@/assets/images/pages/success.png" alt="" width="24" height="24">
      </div>

      <div class="vx-col md:w-2/12 w-full" v-if="checkImportFail">
        <img class="mt-2" src="@/assets/images/pages/refresh.png" alt="" width="24" height="24">
      </div>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx'

export default {
  props: {
    onSuccess: {
      type: Function,
      required: true
    },
    checkFileImport: {
      type: Boolean,
      default : false
    },
    checkImport: {
      type: Boolean,
      default: false
    },
    checkImportFail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      excelData: {
        header: null,
        results: null,
        meta: null,
      },
      // checkImport: false,
      // checkImportFail: false,
      // checkFileImport: false,
      fileName: null,
      percentImport: 0
    }
  },
  methods: {
    generateData({ header, results, meta }) {
      this.excelData.header = header
      this.excelData.results = results
      this.excelData.meta = meta
      setInterval(() => {
        if(this.percentImport <= 99){
          this.percentImport += 1;
        }
        // if (this.onSuccess && this.percentImport == 100) return this.checkImport = true;
        // if (!this.onSuccess) return this.checkImportFail = true;
        // this.checkFileImport = true;
      }, 50);
      setTimeout(() => {
        this.onSuccess && this.onSuccess(this.excelData);
      }, 5000);
    },
    getHeaderRow(sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C
      const R = range.s.r
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
        /* find the cell in the first row */
        let hdr = 'UNKNOWN ' + C // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },
    handleDragover(e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    handleDrop(e) {
      e.stopPropagation()
      e.preventDefault()
      const files = e.dataTransfer.files
      if (files.length !== 1) {
        this.$vs.notify({
            title: 'Login Attempt',
            text: this.$t('onlySupportOneFile'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
        })
        return
      }
      const rawFile = files[0] // only use files[0]
      if (!this.isExcel(rawFile)) {
        this.$vs.notify({
            title: 'Login Attempt',
            text: this.$t('onlySupportsUpload'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
        })
        return false
      }
      this.uploadFile(rawFile)
    },
    readerData(rawFile) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = e => {
          let fileContent = new TextDecoder("utf-8").decode(e.target.result)
          const header = fileContent.split("\n")[0].split(",").map(item => item.trim())
          const results = fileContent.split("\n").slice(1).map (row => row.split(",").map(item => item.trim()))
          const meta = {}
          this.generateData({ header, results, meta })
          resolve()
        }
        reader.readAsArrayBuffer(rawFile)
      })
    },
    refreshImport: function(){
      this.checkImport = false;
      this.checkImportFail = false;
      this.percentImport =  0;
    },
    handleClick(e) {
      this.refreshImport();
      const files = e.target.files
      this.fileName = files[0].name;
      if (files.length > 0) {
        this.checkFileImport = true;
      }
      const rawFile = files[0]
      if (!rawFile) return
      this.uploadFile(rawFile)
    },
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },
    uploadFile(file) {
      this.$refs['fileInput'].value = null // fix can't select the same excel
      this.readerData(file)
    }
  }
}
</script>
<style lang="scss">
.text-import {
  font-size: 18px;
  color: #6E6B7B;
}
.background-import {
  background: rgba(47,128,237,0.05)
}
.stroke-current {
  stroke: #2F80ED !important;
}
.title-import {
  color: #6E6B7B;
  font-size: 21px;
  text-align: center;
  font-weight: bold;
}
.title-text-file {
  color: #6E6B7B;
  font-size: 16px;
  text-align: center;
}
.percent-upload {
  font-size: 14px;
  color: #B9B9C3;
  text-align: right;
}
.file-name {
  font-size: 14px;
  color: #6E6B7B;
}
</style>